import { getWorkspaceInfoV1 } from "apis/workspace/getWorkspaceInfo";
import ReactGA from "react-ga4";

export const gaPageView = (page: string) => {
    ReactGA.send({
        hitType: "pageview",
        page: page,
        title: page,
    });
};

export const gaEvent = (name: string, params: object = {}) => {
    // getWorkspaceInfoV1().then((res) => {
    //     params = {
    //         workspaceName: res?.name,
    //         ...params,
    //     };
    //     ReactGA.event(name, params);
    // });
    ReactGA.event(name, params);
};
